import { loginEncrypt } from '@repo/common-utils/utils/crypto'
import { getBaseUrl } from '@repo/common-utils/utils/url'
import { post, ENCRYPT_TYPES } from '@repo/http/http'
import { showToast } from 'vant'
import i18n from '@repo/i18n/common'
import { isHLApp } from '@fs/utils'

const { VUE_APP_UC = '' } = import.meta.env
const baseUrl = getBaseUrl(VUE_APP_UC)
export const WebCodeSend = (data: any) => {
  if (isHLApp()) {
    return post(`${baseUrl}/uc/v1/AppCodeSend`, {
      data,
      encrypt: 1,
      encTag: 'tempsession/enc',
    })
  }
  return post(`${baseUrl}/uc/v1/WebCodeSend`, {
    data,
    encrypt: ENCRYPT_TYPES.EDCH, // 获取验证码 临时会话加密
    noEncTag: true,
  })
}

export const sendCode = async ({
  scene = 10,
  type = 1,
  value = '',
  areaCode = '',
  captcha = '',
}: {
  scene?: number
  type?: number
  value?: string
  areaCode?: string
  captcha?: string
  Toast?: (message: string) => void
} = {}): Promise<
  | {
      result: {
        salt: string
      }
      error?: {
        code: number
      }
    }
  | false
> => {
  try {
    const res = (await WebCodeSend({
      scene, // 验证码登录
      type, // 手机登录
      value,
      areaCode,
      captcha,
    })) as {
      data: {
        result: {
          salt: string
        }
        error?: {
          code: number
        }
      }
    }
    const data = res?.data
    if (!data?.result || data?.error?.code !== 110112) {
      // @ts-expect-error i18n.global.t is not typed
      showToast(i18n.global.t('yzmfssb'))
      return false
    }
    return data
  } catch {
    showToast(i18n.global.t('requestCode.fwqzwxyqshzs'))
    return false
  }
}

export const CodeVerify = (data: any) => {
  const { value, code, salt } = data
  const { A1 } = loginEncrypt(value, code, salt)

  return post(`${baseUrl}/uc/v1/CodeVerify`, {
    data: {
      salt,
      ticket: A1,
    },
    encrypt: 0,
    noEncTag: true,
  })
}
